import React, { useEffect, useState } from "react";
import {
  Alert,
  Modal,
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Table,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  saveEvaluators,
  resetEvaluators,
} from "../../redux/evaluacion_desempenio/CollaboratorsToEvaluate/actions";
import { getSegment } from "../../redux/climalaboral/segment/actions";
import {
  editCampaña,
  saveCampañaSegmento,
} from "../../redux/climalaboral/campaña/action";
import SegmentDescription from "./SegmentDescription";

const EvaluatorsSelected = (props) => {
  const [viewItem, setViewItem] = useState({});
  const [showModalVisualizationSegmento, setShowModalVisualizationSegmento] =
    useState(false);

  const schema = Yup.object().shape({
    segmento: Yup.string().notRequired(),
  });

  //*States
  const [segmnt, setSegmnt] = useState([]);
  const [segmentSelected, setSegmentSelected] = useState([]);

  //*Redux
  const { loadingWorkFlow, saveLoading, error, successMessage } = useSelector(
    (store) => store.wflowempleados
  );

  // const collaboratorsEvaluateStore = useSelector(
  //   (store) => store.collaboratorsEvaluate
  // );

  // const { evaluators, evaluatorsFail, segmentoLoading } =
  //   collaboratorsEvaluateStore;

  const { loading: segmentoLoading, segmento } = useSelector(
    (store) => store.segment
  );

  const { loading, segment, segmentLength } = useSelector(
    (store) => store.segment
  );

  //*variables
  const dispatch = useDispatch();
  let segmentsOptions = [];
  segment &&
    segment.map((segm) => {
      segmentsOptions = [
        ...segmentsOptions,
        {
          id: segm.id,
          label: segm.nombre,
        },
      ];
    });

  useEffect(() => {
    dispatch(getSegment({}));
  }, []);

  const onSubmit = (req) => {
    try {
      const existItem = segmnt.find(
        (rowItem) => rowItem.id === parseInt(req.segmento)
      );
      if (existItem) {
        toastr.info("El segmento ya ha sido agregado", "", {
          progressBar: true,
          rtl: true,
        });
        return;
      }
    } catch (error) {
      toastr.info("El segmento no es valido", "", {
        progressBar: true,
        rtl: true,
      });
    }
    setSegmnt([...segmnt, segmentSelected[0]]);
    setSegmentSelected([]);
    req.segmento = "";
  };

  const handleRemoveSegment = (ind) => {
    const _segmnt = segmnt.slice();
    _segmnt.splice(ind, 1);
    setSegmnt(_segmnt);
  };

  const handleSaveSegments = () => {
    let req = {
      campanias_segmentos_eliminar: [],
      campanias_segmentos_crear: [],
    };

    // Añadir segmentos a crear
    segmnt.map((item) => {
      req.campanias_segmentos_crear.push({
        campania: props.item.id,
        segmento: item.id,
      });
    });

    // Si hay segmentos para eliminar
    if (props.item.segmento_list) {
      // Mapear los segmentos para eliminar
      props.item.segmento_list.map((item) => {
        let segmento_id = item.segmento_id;
        // Verificar si el segmento a eliminar no está en los segmentos a crear
        let segmentoExistente = req.campanias_segmentos_crear.find(
          (seg) => seg.segmento === segmento_id
        );
        if (!segmentoExistente) {
          req.campanias_segmentos_eliminar.push({
            campania: props.item.id,
            segmento: segmento_id,
          });
        }
      });
    }

    dispatch(saveCampañaSegmento(req, props.handleClose, segmnt, props.index));
    // props.handleClose();
  };

  const viewSegments = () => {
    let segmentTemp = [];
    if (props.item.segmento_list) {
      props.item.segmento_list.map((item) => {
        segmentTemp.push({
          id: item.segmento_id,
          label: item.segmento__nombre,
        });
      });
    }
    setSegmnt(segmentTemp);
    dispatch(resetEvaluators());
    setShowModalVisualizationSegmento(false);
  };

  const onView = (item, index) => {
    setViewItem(item);
    setShowModalVisualizationSegmento(true);
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.show}
        onHide={props.handleClose}
        onShow={viewSegments}
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar segmentos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="border-0">
            <Card.Body>
              <Row>
                <Col sm={12} md={12}>
                  <Formik
                    validationSchema={schema}
                    onSubmit={onSubmit}
                    initialValues={{
                      segmento: "",
                    }}
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      setFieldValue,
                      handleBlur,
                      values,
                      touched,
                      errors,
                    }) => (
                      <>
                        <Form onSubmit={handleSubmit} noValidate>
                          {/* {!segmentoLoading && !!evaluatorsFail && (
                          <Alert variant="danger" className="my-3">
                            {evaluatorsFail}
                          </Alert>
                        )} */}
                          {!!successMessage && (
                            <Alert variant="success" className="my-3">
                              <p>Evaluadores asignados con éxito</p>
                            </Alert>
                          )}
                          <Col>
                            <Row className="d-flex flex-wrap align-items-center">
                              <Col sm={11} className="px-0">
                                <Row className="d-flex flex-wrap align-items-center">
                                  <Col>
                                    <Typeahead
                                      id="segmento"
                                      name="segmento"
                                      isInvalid={
                                        touched.segmento && errors.segmento
                                      }
                                      isValid={
                                        touched.segmento && !errors.segmento
                                      }
                                      onBlur={handleBlur("segmento")}
                                      placeholder="Seleccione un segmento"
                                      options={segmentsOptions}
                                      onChange={(selected) => {
                                        setFieldValue(
                                          "segmento",
                                          selected.length > 0
                                            ? selected[0].id
                                            : ""
                                        );
                                        setSegmentSelected(selected);
                                      }}
                                      selected={segmentSelected}
                                      disabled={segmentoLoading}
                                    ></Typeahead>
                                  </Col>
                                  {/* {segmentoLoading && (
                                  <Col sm={1}>
                                    <Spinner animation="border" size="sm" />
                                  </Col>
                                )} */}
                                </Row>
                                {touched.segmento && !!errors.segmento && (
                                  <Col>
                                    <small className="text-danger">
                                      {errors.segmento}
                                    </small>
                                  </Col>
                                )}
                              </Col>
                              <Col sm={1}>
                                {segmentoLoading ? (
                                  <Col sm={1}>
                                    <Spinner animation="border" size="sm" />
                                  </Col>
                                ) : (
                                  <OverlayTrigger
                                    placement="auto"
                                    overlay={
                                      <Tooltip
                                        {...props}
                                        style={{ zIndex: "9999999999999" }}
                                      >
                                        Agregar segmento
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      size="sm"
                                      className="rounded-circle"
                                      variant="primary"
                                      type="submit"
                                      disabled={segmentSelected.length === 0}
                                    >
                                      <i className="material-icons">add</i>
                                    </Button>
                                  </OverlayTrigger>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Form>
                      </>
                    )}
                  </Formik>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12} md={12}>
                  <div className="my-1">
                    {loadingWorkFlow ? (
                      <div className="d-flex justify-content-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : segmnt.length > 0 ? (
                      <Table>
                        <thead>
                          <tr>
                            <th>segmento</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {segmnt.map((item, ind) => (
                            <tr key={ind}>
                              <td>{item.label}</td>
                              <td>
                                <Button
                                  size="sm"
                                  variant="link"
                                  type="button"
                                  className="text-info"
                                  onClick={() =>
                                    onView(
                                      segment.find((i) => i.id === item.id),
                                      ind
                                    )
                                  }
                                >
                                  <i className="material-icons">visibility</i>
                                </Button>
                                <Button
                                  variant="default"
                                  size="sm"
                                  className="ml-3"
                                  onClick={() => handleRemoveSegment(ind)}
                                >
                                  <i
                                    className="material-icons"
                                    style={{ fontSize: "1.3rem" }}
                                  >
                                    delete
                                  </i>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <Alert variant="info">
                        Aún no hay evaluadores asignados.
                      </Alert>
                    )}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={props.handleClose}
          >
            Cancelar
          </Button>
          <Button
            disabled={segmnt.length === 0 || saveLoading}
            className="rounded-pill"
            variant="primary"
            type="button"
            onClick={() => handleSaveSegments()}
          >
            {saveLoading ? (
              <Spinner
                className="mr-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
      <SegmentDescription
        showModalVisualization={showModalVisualizationSegmento}
        setShowModalVisualization={setShowModalVisualizationSegmento}
        viewItem={viewItem}
      />
    </>
  );
};

export default EvaluatorsSelected;
